module.exports = __webpack_public_path__ + "media/images/games/clash-royale/app-splash-42af24850fd8a6d36ee0ea37772d0ee0.png";